import * as Sentry from '@sentry/vue';
import pkg from '../../package.json';

export const sentry = (app) => {
  // Sentry - Only run in production
  if (window?.location?.host === 'www.garmin.com') {
    const ALLOWED_URL_PATTERNS = [
      /\/p\/assets\//i,
      /static\.garmincdn\.com/i,
      /[a-zA-Z-]+\.klarnaservices\.com/i,
      /product-gallery\.cloudinary\.com/i,
    ];
    Sentry.init({
      app,
      dsn: 'https://803612d6307a45cfbb97a1a67f208e41@o430870.ingest.sentry.io/4504720224878592',
      release: `${pkg.name}@${pkg.version}`,
      environment: 'production',
      logErrors: true,
      allowUrls: ALLOWED_URL_PATTERNS,
      /**
       * This drops any event that has no frame from the ALLOWED_URL_PATTERNS
       * @param {object} event     - Sentry processed event object provide to beforeSend callback
       *                           - More details can be found here: https://docs.sentry.io/platforms/javascript/guides/vue/configuration/filtering/#using-platformidentifier-namebefore-send-
       * @returns {(object|null)} - Returns null if event is intended to be filtered out from logging to Sentry, otherwise it returns the event object
       */
      beforeSend(event) {
        const exceptionDetails = event?.exception?.values?.[0];
        const exceptionValue = exceptionDetails?.value;
        const frames = exceptionDetails?.stacktrace?.frames ?? [];

        const hasAllowedFrame = frames.some((frame) => ALLOWED_URL_PATTERNS.some((pattern) => pattern.test(frame?.filename ?? '')));

        if (!exceptionValue || !hasAllowedFrame) {
          return null;
        }

        return event;
      },
    });
  }
};

export default sentry;
